export default __webpack_public_path__ + "static/media/photo--sm--74.cd38cef5.jpg";